import { Box, styled } from '@mui/material';
var StyledPopupContentContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  };
  return styles;
});
export { StyledPopupContentContainer };